import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';

import user from '../assets/images/user.png';
import logo from '../assets/svg/cms.svg';

import en from '../assets/images/en.png';
import de from '../assets/images/de.png';


class Header extends Component {

  constructor(props) {
    super(props);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      langIco: en
    };
  }


  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }


  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        langs: null,
        account: null
      });
    }
  }


  render() {

    return (

      <header>

        <div className="hamburger" onClick={() => this.props.handleSidebar(!this.props.sidebar)}>
          <i className="mdi mdi-view-headline"></i>
        </div>

        {
          <div className="logo">
            <Isvg src={logo} />
          </div>
        }
        <div className="language">
          <button className="button" onClick={() => this.setState({ langs: !this.state.langs })}> <img src={this.state.langIco} /> {this.props.lang ==='en' ? 'EN' : 'DE'}</button>
          {this.state.langs ?
            <ul className="menu" ref={(node) => this.wrapperRef = node}>
              <li onClick={() => { this.props.setLang('en'); this.setState({ langs: null, langIco: en }); }}><img src={en} />EN</li>
              <li onClick={() => { this.props.setLang('de'); this.setState({ langs: null, langIco: de }); }} ><img src={de} />DE</li>

            </ul>

            : null
          }
        </div>


        <div className="user" onClick={() => this.setState({ account: !this.state.account })}>
          <span>{this.props.uData ? this.props.uData.username : ''}</span>
          <img src={user} />
          {this.state.account ?
            <ul className="menu" ref={(node) => this.wrapperRef = node}>
              <li onClick={() => this.props.setUserData(null)}><i className="mdi mdi-power" />{this.props.translate('LogOut')}</li>

            </ul>

            : null
          }

        </div>



      </header>
    )
  }

};

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.js